module.exports = __webpack_public_path__ + "img/7.cc4151b5.png";